import { Authentication } from '@/store';
import { getColors } from '@/styles/updateColors';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../pages/login/loginPage.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../pages/dashboard/DashboardPage.vue'),
    meta: {
      icon: 'HouseIcon',
      divider: true,
    },
  },
  {
    path: '/agentes',
    name: 'Agentes',
    component: () => import('../pages/agents/AgentsPage.vue'),
    meta: {
      icon: 'HouseIcon',
      divider: true,
    },
  },
  {
    path: '/relatorios',
    name: 'Relatórios',
    component: () => import('../pages/relatory/RelatoryPage.vue'),
    meta: {
      icon: 'HouseIcon',
      divider: false,
    },
  },
  {
    path: '/beds',
    name: 'Leitos',
    component: () => import('../pages/beds/BedsPage.vue'),
    meta: {
      icon: 'MonitorMobbileIcon',
    },
  },
  {
    path: '/settings',
    name: 'Configurações',
    component: () => import('../pages/settings/SettingsPage.vue'),
    meta: {
      icon: 'MonitorMobbileIcon',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  Authentication.actions.ActionCheckToken();
  getColors();
  const token = Authentication.getters.getUser.value?.token;

  if (!token && to.name !== 'Login') {
    next({ name: 'Login' });
  } else if (token && to.path == '/') {
    next('/dashboard');
  } else {
    next(true);
  }
});
export { routes };
export default router;
